// src/components/Logout.js
import { useEffect, useContext } from 'react';
import axiosInstance from '../axiosConfig';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

function Logout() {
  const { logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    // Call the backend to invalidate the refresh token
    axiosInstance
      .post(
        '/api/v1/logout/',
        {
          refresh_token: localStorage.getItem('refresh_token'),
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('_auth')}`,
          },
        }
      )
      .then((response) => {
        // Successfully logged out on the backend
        logoutUser();
        navigate('/chess');
      })
      .catch((error) => {
        console.error('Logout error:', error);
        logoutUser();
        navigate('/chess');
      });
  }, [logoutUser, navigate]);

  return null;
}

export default Logout;
